/* eslint-disable */
import { AppPermissions } from '@core/permission/permission.constants';
import { PLANNED_FEATURES } from '@core/availability/feature-availability';
import { FuseNavigationItem } from '@fuse/components/navigation';

/** Planned pages remain accessible; the muted styling only marks their status. */
function plannedItem(id: string, title: string, icon: string, permission?: string): FuseNavigationItem {
    const feature = PLANNED_FEATURES.find(feature => feature.id === id);
    if (!feature) throw new Error(`Missing feature availability: ${id}`);
    return {
        id,
        title,
        icon,
        type: 'basic',
        link: feature.path,
        classes: { wrapper: 'mzeit-nav-planned' },
        meta: { permission, availability: 'planned' },
    };
}

export const defaultNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboard',
        title: 'M-Zeit Cockpit',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/dashboard',
    },
    { id: 'team-dashboard', title: 'Teamcockpit', type: 'basic', icon: 'heroicons_outline:user-group', link: '/team-dashboard', meta: { permission: AppPermissions.Employee.List } },
    {
        id: 'worktime.title',
        title: 'Arbeitszeit',
        type: 'collapsable',
        children: [
            {
                id: 'worktime.entries.heading',
                title: 'Einträge',
                type: 'group',
                classes: { wrapper: 'mzeit-nav-heading' },
                children: [
                    {
                        id: 'worktime.new.title',
                        title: 'Arbeitszeit eintragen',
                        type: 'basic',
                        icon: 'mat_outline:more_time',
                        link: '/work-time/sessions/new',
                        classes: {
                            wrapper: 'nav-no-active',
                        },
                        meta: { permission: AppPermissions.WorkTime.Create },
                    },
                    {
                        id: 'worktime.change-requests',
                        title: 'Änderungsanträge',
                        type: 'basic',
                        icon: 'heroicons_outline:document-text',
                        link: '/work-time/change-requests',
                        meta: { permission: AppPermissions.WorkTime.Read },
                    },
                ],
            },
            {
                id: 'worktime.reports.heading',
                title: 'Auswertungen',
                type: 'group',
                classes: { wrapper: 'mzeit-nav-heading' },
                children: [
                    {
                        id: 'worktime.list',
                        title: 'Listenansicht',
                        type: 'basic',
                        link: '/work-time/sessions',
                        icon: 'mat_outline:list',
                        meta: { permission: AppPermissions.WorkTime.Read },
                    },
                    {
                        id: 'worktime.balance',
                        title: 'Zeitbilanz',
                        type: 'basic',
                        link: '/time-balance',
                        icon: 'mat_outline:pending_actions',
                        meta: { permission: AppPermissions.Report.DailyOvertimeRead },
                    },
                    {
                        id: 'worktime.time-account',
                        title: 'Zeitsaldo',
                        type: 'basic',
                        link: '/time-account',
                        icon: 'mat_outline:history',
                        meta: { permission: AppPermissions.Report.TimeAccountListRead },
                    },
                    plannedItem('worktime.team-capacity', 'Teamauslastung', 'heroicons_outline:chart-bar', AppPermissions.Employee.List),
                    plannedItem('worktime.project-report', 'Projektauswertung', 'heroicons_outline:folder-open', AppPermissions.Employee.List),
                    {id:'worktime.attendance',title:'Anwesenheitsliste',type:'basic',icon:'mat_outline:groups',link:'/work-time/attendance',meta:{permission:AppPermissions.Attendance.Read}},
                ],
            },
            {
                id: 'worktime.overviews.heading',
                title: 'Übersichten',
                type: 'group',
                classes: { wrapper: 'mzeit-nav-heading' },
                children: [
                    {
                        id: 'worktime.attendance-calendar',
                        title: 'Meine Anwesenheit',
                        type: 'basic',
                        icon: 'heroicons_outline:calendar-days',
                        link: '/attendance-calendar',
                        meta: { permission: AppPermissions.Report.DailyOvertimeRead },
                    },
                    {
                        id: 'worktime.attendance-overview',
                        title: 'Anwesenheitskalender',
                        type: 'basic',
                        icon: 'heroicons_outline:calendar-days',
                        link: '/attendance-overview',
                        meta: { permission: AppPermissions.Report.DailyOvertimeRead },
                    },
                ],
            },
        ],
    },
    {
        id: 'absence.title',
        title: 'Abwesenheiten',
        type: 'collapsable',
        children: [
            {
                id: 'absence.personal.heading',
                title: 'Für mich',
                type: 'group',
                classes: { wrapper: 'mzeit-nav-heading' },
                children: [
                    {
                        id: 'absence.request.open',
                        title: 'Abwesenheit eintragen',
                        type: 'basic',
                        icon: 'mat_outline:event_busy',
                        classes: {
                            wrapper: 'nav-no-active',
                        },
                        meta: { permission: AppPermissions.Absence.Create },
                    },
                    {
                        id: 'absence.my-calendar',
                        title: 'Meine Abwesenheit',
                        type: 'basic',
                        icon: 'heroicons_outline:calendar-days',
                        link: '/absence-calendar',
                        meta: { permission: AppPermissions.Absence.Read },
                    },
                    {
                        id: 'absence.account.overview',
                        title: 'Mein Urlaub',
                        type: 'basic',
                        link: '/vacation/account',
                        icon: 'mat_outline:list',
                        meta: { permission: AppPermissions.Vacation.Balance.Read },
                    },
                ],
            },
            {
                id: 'absence.team.heading',
                title: 'Teamübersichten',
                type: 'group',
                classes: { wrapper: 'mzeit-nav-heading' },
                children: [
                    {
                        id: 'absence.overview',
                        title: 'Abwesenheitskalender',
                        type: 'basic',
                        icon: 'heroicons_outline:calendar-days',
                        link: '/absence-overview',
                        meta: { permission: AppPermissions.Absence.Read },
                    },
                    {
                        id: 'absence.list',
                        title: 'Abwesenheitsliste',
                        type: 'basic',
                        link: '/administration/absence-list',
                        icon: 'mat_outline:list',
                        meta: { permission: AppPermissions.Absence.Read },
                    },
                ],
            },
            {
                id: 'absence.management.heading',
                title: 'Anträge & Urlaubskonten',
                type: 'group',
                classes: { wrapper: 'mzeit-nav-heading' },
                children: [
                    {
                        id: 'absence.request.list',
                        title: 'Abwesenheitsanträge',
                        type: 'basic',
                        link: '/administration/absence-requests',
                        icon: 'mat_outline:fact_check',
                        meta: { permission: AppPermissions.Absence.Read },
                    },
                    {
                        id: 'absence.account.overview-list',
                        title: 'Urlaubskontoübersicht',
                        type: 'basic',
                        link: '/vacation/account-overview',
                        icon: 'mat_outline:groups',
                        meta: { permission: AppPermissions.Vacation.Balance.Read },
                    },
                ],
            },
        ],
    },
    {
        id: 'administration.title',
        title: 'Verwaltung',
        type: 'collapsable',
        children: [
            { id: 'administration.overview', title: 'Übersicht', type: 'basic', icon: 'heroicons_outline:squares-2x2', link: '/administration/overview' },
            {
                id: 'administration.master-data.heading',
                title: 'Stammdaten',
                type: 'group',
                classes: { wrapper: 'mzeit-nav-heading' },
                children: [
                    {
                        id: 'administration.employee-management',
                        title: 'Mitarbeiter',
                        type: 'basic',
                        link: '/administration/employee-management',
                        icon: 'mat_outline:manage_accounts',
                        meta: { permission: AppPermissions.Employee.List },
                    },
                    {
                        id: 'administration.department-management',
                        title: 'Abteilungen',
                        type: 'basic',
                        link: '/administration/department-management',
                        icon: 'mat_outline:account_tree',
                        meta: { permission: AppPermissions.Department.Manage },
                    },
                    {
                        id: 'administration.location-management',
                        title: 'Stand- & Arbeitsorte',
                        type: 'basic',
                        link: '/administration/location-management',
                        icon: 'mat_outline:edit_location',
                        meta: { permission: AppPermissions.Location.Manage },
                    },
                    {
                        id: 'administration.superior-assignment',
                        title: 'Organigramm',
                        type: 'basic',
                        link: '/administration/superior-assignment',
                        icon: 'mat_outline:supervisor_account',
                        meta: { permission: AppPermissions.Employee.AssignSuperior },
                    },
                    plannedItem('administration.projects', 'Projektstamm', 'heroicons_outline:briefcase'),
                ],
            },
            {
                id: 'administration.rules.heading',
                title: 'Regelwerk',
                type: 'group',
                classes: { wrapper: 'mzeit-nav-heading' },
                children: [
                    plannedItem('administration.access-control', 'Zugriffssteuerung', 'heroicons_outline:shield-check', AppPermissions.Employee.AssignSuperior),
                    {
                        id: 'administration.time-profile-management',
                        title: 'Zeitprofile',
                        type: 'basic',
                        link: '/administration/time-profile-management',
                        icon: 'mat_outline:more_time',
                        meta: { permission: AppPermissions.TimeProfile.Manage },
                    },
                    {
                        id: 'administration.break-policy-management',
                        title: 'Pausenregeln',
                        type: 'basic',
                        link: '/administration/break-policy-management',
                        icon: 'mat_outline:coffee',
                        meta: { permission: AppPermissions.BreakPolicy.Manage },
                    },
                    {
                        id: 'administration.absence-type-management',
                        title: 'Abwesenheitstypen definieren',
                        type: 'basic',
                        link: '/administration/absence-type-management',
                        icon: 'mat_outline:category',
                        meta: { permission: AppPermissions.AbsenceType.Manage },
                    },
                    plannedItem('administration.company-days', 'Betriebsurlaub', 'heroicons_outline:calendar-days'),
                    plannedItem('administration.time-limits', 'Zeitgrenzen', 'heroicons_outline:adjustments-horizontal', AppPermissions.TimeProfile.Manage),
                ],
            },
            {
                id: 'administration.accounts.heading',
                title: 'Kontenverwaltung',
                type: 'group',
                classes: { wrapper: 'mzeit-nav-heading' },
                children: [
                    {
                        id: 'administration.vacation-entitlement-management',
                        title: 'Urlaubskonten',
                        type: 'basic',
                        link: '/administration/vacation-entitlement-management',
                        icon: 'mat_outline:beach_access',
                        meta: { permission: AppPermissions.Vacation.Entitlement.Update },
                    },
                    {
                        id: 'time-account-booking.title',
                        title: 'Zeitkonten',
                        type: 'basic',
                        link: '/time-account-booking',
                        icon: 'mat_outline:iso',
                        meta: { permission: AppPermissions.TimeAccountPosting.Create },
                    },
                ],
            },
        ],
    },
    {
        id: 'administration.settings',
        title: 'Administration',
        type: 'collapsable',
        children: [
            plannedItem('administration.license', 'Lizenz- und Funktionsumfang', 'heroicons_outline:key'),
            plannedItem('administration.billing', 'Rechnungs- und Kontaktdaten', 'heroicons_outline:credit-card'),
            { id: 'administration.customization', title: 'Individualisierung', type: 'basic', icon: 'heroicons_outline:adjustments-horizontal', link: '/administration/customization', meta: { permission: 'Tenant.Update' } },
        ],
    },
    {
        id: 'administration.installApp',
        title: 'Als App laden',
        type: 'basic',
        link: '/administration/install-app',
        icon: 'heroicons_outline:arrow-down-tray',
        classes: { wrapper: 'install-app-navigation' },
    },
];
export const compactNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboard',
        title: 'Mein Cockpit',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/dashboard',
    },
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboard',
        title: 'Mein Cockpit',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/dashboard',
    },
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboard',
        title: 'Mein Cockpit',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/dashboard',
    },
];
